export function resolveAuthorPrefix(prefix: string | undefined, name: string) {
  if (!prefix) {
    return name;
  }

  return `${prefix} ${name}`;
}
